module.exports = __webpack_public_path__ + "img/img6.b3d55c3c.png";